import { Theme } from '@opallabs/gem'
import { ThemeProvider } from '@opallabs/hooks'
import { Reaction } from './Reaction'
import * as styles from './styles'

type Reaction = {
  display_name: string
  emoji: string
  id: number
  reaction_type_id: number
  removable: boolean
  usernames: string[]
}

interface Props {
  theme?: Theme
  reactions: Reaction[]
  onClickReaction: (
    reactionId: number,
    reactionTypeId: number,
    removable: boolean
  ) => void
}

export const ReactionList: React.FC<Props> = ({
  theme = 'light',
  reactions,
  onClickReaction,
}) => (
  <ThemeProvider theme={theme}>
    <ul css={styles.reactionWrapper}>
      {reactions &&
        reactions.map((reaction) => (
          <Reaction
            key={`reaction-${reaction.id}`}
            displayName={reaction.display_name}
            emoji={reaction.emoji}
            reactionId={reaction.id}
            reactionTypeId={reaction.reaction_type_id}
            removable={reaction.removable}
            usernames={reaction.usernames}
            onClickReaction={(
              reactionId: number,
              reactionTypeId: number,
              removable: boolean
            ): void => onClickReaction(reactionId, reactionTypeId, removable)}
          />
        ))}
    </ul>
  </ThemeProvider>
)
